<template>
  <div>
    <form-control
      v-model="data.name"
      :errors="error ? error.errors.name : []"
      title="Name"
    />
    <form-control
      v-model="data.short_name"
      :errors="error ? error.errors.short_name : []"
      title="Short Name"
    />



    <form-control
      v-model="data.locations"
      :errors="error ? error.errors['locations'] : []"
      title="Locations"
    />

    <form-control
      v-model="data.url"
      :errors="error ? error.errors.url : []"
      title="Website"
    />

    <form-control
      v-model="data.email"
      :errors="error ? error.errors.email : []"
      title="Email"
    />

    <div class="form-group">
      <label>Sectors</label>
      <multiselect
        v-model="data.sectors"
        :options="sectors"
        :internal-search="false"
        :allow-empty="true"
        :searchable="true"
        :multiple="true"
        :show-labels="false"
        class="multiselect"
        style="cursor:pointer"
        select-label="Select"
        label="name"
        track-by="id"
      >
        <form-control-error
          :errors="(error && error.errors.sectors) ? error.errors.sectors : []"
        />
      </multiselect>
    </div>

    <div class="form-group">
      <label>
        Long Summary
      </label>
      <textarea
        v-model="data.long_summary"
        class="d-none d-md-block form-control"
        :class="{
          'is-invalid': ((error && error.errors.teaser_text) ? error.errors.teaser_text : []).length > 0
        }"
      />
    </div>

    <div class="form-group">
      <label id="shortSummaryEditor" class="d-flex w-100">
        <span>
        Short Summary
        </span>
        <span class="ml-auto text-lightgray">
            {{ shortSummaryLength }} /  250
        </span>
      </label>
      <form-control
        v-model="data.short_summary"
        type="textarea"
        :errors="((highlightFields && shortSummaryLength > 250)?'Please keep the character limitation.':null)||(error ? error.errors['short_summary'] : [])"
        :class="{
              'is-invalid': (highlightFields && shortSummaryLength > 250) || (((error && error.errors.short_summary) ? error.errors.short_summary : []).length > 0)
            }"
      />
    </div>

    <div class="form-group">
      <label>Header</label>

      <div>
        <img
          v-if="data.header_image_url"
          :src="data.header_image_url"
          :alt="data.name"
          class="mb-2"
          width="64"
        >
      </div>

      <FileUpload
        :accept="['image/png', 'image/jpeg']"
        :headers="headers()"
        :value="data.header_image_url ? [{name: data.header_image_url, url: data.header_image_url}] : null"
        @input="headerUploaded"
        :action="url() + 'channels/logo'"
        :data="{params: {provider_name: data.name, prefix: 'header'}}"
      />
    </div>

    <div class="form-group">
      <label>Logo</label>

      <div>
        <img
          v-if="data.logo_url"
          :src="data.logo_url"
          :alt="data.name"
          class="mb-2"
          width="64"
        >
      </div>

      <FileUpload
        :accept="['image/png', 'image/jpeg']"
        :headers="headers()"
        :value="data.logo_url ? [{name: data.logo_url, url: data.logo_url}] : null"
        @input="logoUploaded"
        :action="url() + 'channels/logo'"
        :data="{params: {provider_name: data.name}}"
      />
    </div>

    <div class="form-group">
      <label>Email Logo</label>

      <div>
        <img
          v-if="data.email_logo_url"
          :src="data.email_logo_url"
          :alt="data.name"
          class="mb-2"
          width="64"
        >
      </div>
      <FileUpload
        :accept="['image/png', 'image/jpeg']"
        :value="data.email_logo_url ? [{name: data.email_logo_url, url: data.email_logo_url}] : null"
        :headers="headers()"
        @input="emailLogoUploaded"
        :action="url() + 'channels/logo'"
        :data="{params: {provider_name: data.name, prefix: 'email'}}"
      />
    </div>

    <div class="form-group">
      <label>Badge</label>

      <div>
        <img
          v-if="data.badge_url"
          :src="data.badge_url"
          :alt="data.name"
          class="mb-2"
          width="64"
        >
      </div>

      <FileUpload
        :accept="['image/png', 'image/jpeg']"
        :value="data.badge_url ? [{name: data.badge_url, url: data.badge_url}] : null"
        :headers="headers()"
        @input="badgeUploaded"
        :action="url() + 'channels/logo'"
        :data="{params: {provider_name: data.name, prefix: 'badge'}}"
      />
    </div>

    <social-link v-model="data.social_links" />

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.can_autopublish"
      >
        Auto publish content
      </t-checkbox>
    </div>

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.analysts_can_publish"
      >
        Analysts can publish their own articles
      </t-checkbox>
    </div>

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.upload_pdf_only"
      >
        To publish, a PDF must be present
      </t-checkbox>
    </div>

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.is_free"
      >
        Is free (not pro)
      </t-checkbox>
    </div>

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.is_shown"
      >
        Is shown (visible)
      </t-checkbox>
    </div>

    <div class="form-group mt-2 mb-0">
      <t-checkbox
        v-model="data.is_co_branded"
      >
        Is co-branded
      </t-checkbox>
    </div>

    <div class="d-flex save-footer mb-3">
      <button
        @click="save"
        class="ml-auto btn btn-primary"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import {HtmlEditor, FileUpload} from '@frontend/components'
import SocialLink from '@/components/SocialLink'
import {getSectors} from '@/helpers'
import {errorNotification} from '@/notifications'

export default {
  components: {
    SocialLink,
    FileUpload,
    HtmlEditor,
  },

  props: {
    value: {
      required: false,
      type: Object,
      default () {
        return {
          default_address: {},
          upload_pdf_only: true,
          analysts_can_publish: false,
          long_summary: null,
          short_summary: null,
          sectors: [],
          social_links: null,
          is_free: false,
        }
      },
    },
  },

  data () {
    return {
      error: null,
      highlightFields: false,
      data: null,
      loading: false,
      logo: [],
      emailLogo: [],
      badge: [],
      sectors: [],
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  beforeMount () {
    this.data = this.value
  },

  mounted () {
    getSectors().then((response) => {
      this.sectors = response.data
    })
  },

  computed:{
    shortSummaryLength: function(){
      return this.value?.short_summary?.length ?? 0
    },
  },

  methods: {

    validate() {
      if(this.shortSummaryLength>250){
        this.highlightFields = true
        this.$notify(errorNotification('Please keep the character limitation.'))
        this.$scrollTo('#shortSummaryEditor')
        setTimeout(() => this.highlightFields = false, 7000)
        return false
      }
      this.highlightFields = false
      return true
    },
    save () {
      if(!this.validate()){
        return
      }
      const method = this.data.id ? 'put' : 'post'
      const url = this.data.id ? `/channels/${this.data.id}` : '/channels'

      this.$http[method](url, this.data)
          .then(this.success)
          .catch(this.fail)
    },

    headers () {
      return {
        Authorization: 'Bearer ' + this.$login.getToken(),
      }
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    url () {
      return process.env.VUE_APP_API_ENDPOINT
    },

    logoUploaded (fileList) {
      const logo = fileList[0]
      this.data.logo = logo ? logo.name : null
      this.data.logo_url = logo ? logo.url : null
    },

    headerUploaded (fileList) {
      const logo = fileList[0]
      this.data.header_image = logo ? logo.name : null
      this.data.header_image_url = logo ? logo.url : null
    },

    emailLogoUploaded (response) {
      const logo = response[0]
      this.data.email_logo = logo ? logo.name : null
      this.data.email_logo_url = logo ? logo.url : null
    },

    badgeUploaded (response) {
      const badge = response[0]
      this.data.badge = badge ? badge.name : null
      this.data.badge_url = badge ? badge.url : null
    },

    success (response) {
      this.$emit('save-success', response)
    },

    fail (error) {
      this.loading = false
      if (error.response && error.response.data && error.response.data.errors) {
        this.error = error.response.data
      }
      this.$emit('save-fail', error)
    },
  },
}
</script>
